import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'layouts/supporter/Layout';
import SubmitButton from 'components/SubmitButton';
import { IconChevronLeft, IconClose } from 'components/Svg';

const Search: React.FC = () => {
  const navigate = useNavigate();
  const [showResult, setShowResult] = useState(false); // 追加

  const request = {
    requestNo: '250831124201',
    username: '店舗A',
    supportername: '山田太郎',
    address: '〒178-0061 練馬区大泉学園町 練馬区大泉学園町',
    phone: '01234567890',
  };

  const handleSearchSubmit = () => {
    // submit logic
    setShowResult(true); // 検索結果表示
  };

  const handleSubmit = () => {
    // submit logic
    navigate('/supporter/rescue-report/add'); // レポート入力ページへ遷移
  };

  return (
    <Layout>
      <div className="p-4">
        {/* Header: 最上位階層のみtitleとicon */}
        <div className="flex items-center justify-between">
          <button className="p-2" onClick={() => navigate(-1)}>
            <IconChevronLeft />
          </button>
          <div className="flex flex-col items-center flex-1">
            <span className="text-lg font-medium text-gray-900">レスキュー作業報告</span>
          </div>
          <button className="p-2" onClick={() => navigate('/supporter')}>
            <IconClose />
          </button>
        </div>

        {/* Content */}
        <main className="flex-1 px-4 py-2 overflow-auto">
          {/* Form fields */}
          <div className="space-y-4 text-sm text-gray-800">
            <div>
              <label className="block mb-1 text-gray-500">レスキュー案件番号</label>
              <input type="text" className="w-full p-2 bg-white border border-gray-300 rounded-lg"/>
            </div>
          </div>
        </main>

        <div className="px-4 py-6 shadow-top">
          <div className="flex flex-col items-center mb-2 text-sm">
            <div className="flex justify-center w-1/5 space-x-4">
              <SubmitButton onClick={handleSearchSubmit}>
                検索
              </SubmitButton>
            </div>
          </div>
        </div>

        {showResult && (
          <div id="after-search">
            {/* Content: 検索後 */}
            <div className="flex flex-col items-center mt-4">
              <div className="text-lg font-medium text-gray-900">検索結果</div>
            </div>
            <main className="flex-1 px-4 overflow-auto">
              {/* Request info */}
              <div className="p-4 mt-6 text-sm text-gray-800 bg-white shadow rounded-2xl">
                <div className="mb-2 text-base font-semibold text-gray-600">依頼情報</div>
                <dl className="grid grid-cols-1 gap-x-8 gap-y-4">
                  <div>
                    <dt className="mb-1 text-gray-500">レスキュー案件番号</dt>
                    <dd className="font-semibold">{request.requestNo}</dd>
                  </div>
                  <div>
                    <dt className="mb-1 text-gray-500">店舗名</dt>
                    <dd className="font-semibold">{request.username}</dd>
                  </div>
                  <div>
                    <dt className="mb-1 text-gray-500">担当者名</dt>
                    <dd className="font-semibold">{request.supportername}</dd>
                  </div>
                  <div>
                    <dt className="mb-1 text-gray-500">訪問先住所</dt>
                    <dd className="font-semibold">{request.address}</dd>
                  </div>
                  <div>
                    <dt className="mb-1 text-gray-500">訪問先電話番号</dt>
                    <dd className="font-semibold">{request.phone}</dd>
                  </div>
                </dl>
              </div>
            </main>
            <div className="px-4 py-6 shadow-top">
              <div className="flex flex-col items-center mb-2 text-sm">
                <div className="flex justify-center w-1/5 space-x-4">
                  <SubmitButton onClick={handleSubmit}>
                    レポートを入力する
                  </SubmitButton>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Search;